module.exports = __webpack_public_path__ + "static/media/finallogo.0d16934a.jpg";